import { render, staticRenderFns } from "./CurrencyField.vue?vue&type=template&id=00f4c573&"
import script from "./CurrencyField.vue?vue&type=script&lang=js&"
export * from "./CurrencyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00f4c573')) {
      api.createRecord('00f4c573', component.options)
    } else {
      api.reload('00f4c573', component.options)
    }
    module.hot.accept("./CurrencyField.vue?vue&type=template&id=00f4c573&", function () {
      api.rerender('00f4c573', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/components/fields/CurrencyField.vue"
export default component.exports